import PropTypes from "prop-types"
import React, { useContext, useEffect, useState } from "react"
import { Row, Col, CardBody, Card, Container, Form, Input } from "reactstrap"
import { Link, useNavigate } from "react-router-dom"
import withRouter from "../../components/Common/withRouter"
import apiHandler from "../../common/config/apiHandler"
import { DataContext } from "../../context/dataContext"
import toast from "react-hot-toast"
import Loader from "../../components/Loader/loader"
import useValidation from "../../hooks/useValidation"
import logo from "../../assets/images/logo-dark.png"
import logolight from "../../assets/images/logo-dark.png"

const Login = props => {
  const navigate = useNavigate()
  document.title = "Login | Smart Parking Deals | Dashboard"

  const [loading, setLoading] = useState(false)
  const { validate, errors, setErrors } = useValidation()

  const { email, password, setToken, setEmail, setPassword } =
    useContext(DataContext)

  const handleSubmit = async e => {
    e.preventDefault()

    const validationErrors = validate({ email, password }, "Login")
    if (!validationErrors) {
      return
    }
    setLoading(true)

    try {
      const response = await apiHandler({
        endpoint: "/backend/login",
        method: "POST",
        data: { email, password },
        options: {
          "Content-Type": "application/json",
          // Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
        },
      })

      if (response?.code === 200) {
        setLoading(false)
        const { user, token } = response.data
        toast.success(response?.message)
        setToken(token)
        localStorage.setItem("user", JSON.stringify(user))
        localStorage.setItem("token", token)
        navigate("/allbookings")
      } else {
        setLoading(false)
        toast.error(response?.message || "Validation error")
      }
    } catch (err) {
      setLoading(false)
      console.error("Login Error:", err.response?.data?.message)
      toast.error(err.response?.data?.message || "Something went wrong!")
    }
  }

  useEffect(() => {
    document.body.className = "authentication-bg"
    return () => {
      document.body.className = ""
    }
  }, [])
  return loading ? (
    <Loader />
  ) : (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="align-items-center justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card>
                <CardBody className="p-4">
                  <Row>
                    <Col lg={12}>
                      <div className="text-center">
                        <Link to="/" className="mb-2 d-block auth-logo">
                          <img
                            src={logo}
                            alt="Logo"
                            height="80"
                            className="logo logo-dark"
                          />
                          <img
                            src={logolight}
                            alt="Logo Light"
                            height="60"
                            className="logo logo-light"
                          />
                        </Link>
                      </div>
                    </Col>
                  </Row>

                  <div className="text-center mt-2">
                    <h5 className="text-primary">
                      Welcome to Smart Parking Deals. !
                    </h5>
                  </div>
                  <div className="p-2 mt-4">
                    <Form onSubmit={handleSubmit}>
                      <div className="mb-3">
                        <label className="form-label fw-bold">Email</label>
                        <Input
                          name="email"
                          type="text"
                          className="form-input"
                          placeholder="Enter email"
                          onChange={e => {
                            setEmail(e.target.value)
                            setErrors(prev => ({ ...prev, email: "" }))
                          }}
                          value={email}
                          invalid={errors.email}
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label fw-bold">Password</label>
                        <Input
                          name="password"
                          type="password"
                          className="form-input"
                          onChange={e => {
                            setPassword(e.target.value)
                            setErrors(prev => ({ ...prev, password: "" }))
                          }}
                          placeholder="Enter Password"
                          value={password}
                          invalid={errors?.password}
                        />
                      </div>

                      <div className="mt-3">
                        <button className="btn btn-primary w-100" type="submit">
                          Log In
                        </button>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  © {new Date().getFullYear()} Smart Parking Deals. Crafted with{" "}
                  <i className="mdi mdi-heart text-danger"></i> by Binary Ops
                  Team.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Login)

Login.propTypes = {
  error: PropTypes.any,
  router: PropTypes.object,
}
